import { render } from "./AdultsSectionThree.vue?vue&type=template&id=265d7d53&scoped=true"
const script = {}

import "./AdultsSectionThree.vue?vue&type=style&index=0&id=265d7d53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265d7d53"]])

export default __exports__